import axios from 'axios'
import store from '@/store'
import { isAdminApiUrl, parseApiError } from '@/utils/apiError'
import { showAdminErrorAlert } from '@/utils/adminErrorHandler'

const request = axios.create({
  baseURL: '/api',
  timeout: 180000
})

function shouldHandleAdminError(config) {
  if (!config || config.silentError) return false
  if (config.useAdminAuth) return true
  return isAdminApiUrl(config.url || '')
}

function rejectWithHandler(error, config) {
  const err = parseApiError(error)
  if (shouldHandleAdminError(config)) {
    showAdminErrorAlert(err)
  }
  return Promise.reject(err)
}

request.interceptors.request.use(
  config => {
    const url = config.url || ''
    const isAdminApi = isAdminApiUrl(url) || config.useAdminAuth === true
    const token = isAdminApi
      ? store.getters.adminToken
      : store.getters.token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => Promise.reject(parseApiError(error))
)

request.interceptors.response.use(
  response => {
    const res = response.data
    const config = response.config || {}
    if (res.code !== 0) {
      const err = parseApiError({
        response: { status: response.status, data: res }
      })
      if (shouldHandleAdminError(config)) {
        showAdminErrorAlert(err)
      }
      return Promise.reject(err)
    }
    return res.data
  },
  error => rejectWithHandler(error, error.config || {})
)

export function fetchHealth() {
  return request.get('/health')
}

export default request
